export default Object.freeze([
	{
		id: 203,
		countryCode: 'US',
		countryName: 'United States',
	},
	{
		id: 1,
		countryCode: 'AF',
		countryName: 'Afghanistan',
	},
	{
		id: 2,
		countryCode: 'AL',
		countryName: 'Albania',
	},
	{
		id: 3,
		countryCode: 'DZ',
		countryName: 'Algeria',
	},
	{
		id: 222,
		countryCode: 'AS',
		countryName: 'American Samoa',
	},
	{
		id: 4,
		countryCode: 'AD',
		countryName: 'Andorra',
	},
	{
		id: 5,
		countryCode: 'AO',
		countryName: 'Angola',
	},
	{
		id: 6,
		countryCode: 'AI',
		countryName: 'Anguilla',
	},
	{
		id: 7,
		countryCode: 'AG',
		countryName: 'Antigua & Barbuda',
	},
	{
		id: 8,
		countryCode: 'AR',
		countryName: 'Argentina',
	},
	{
		id: 9,
		countryCode: 'AM',
		countryName: 'Armenia',
	},
	{
		id: 10,
		countryCode: 'AW',
		countryName: 'Aruba',
	},
	{
		id: 11,
		countryCode: 'SH',
		countryName: 'Ascension',
	},
	{
		id: 12,
		countryCode: 'AU',
		countryName: 'Australia',
	},
	{
		id: 13,
		countryCode: 'AT',
		countryName: 'Austria',
	},
	{
		id: 14,
		countryCode: 'AZ',
		countryName: 'Azerbaijan',
	},
	{
		id: 15,
		countryCode: 'BS',
		countryName: 'Bahamas',
	},
	{
		id: 16,
		countryCode: 'BH',
		countryName: 'Bahrain',
	},
	{
		id: 17,
		countryCode: 'BD',
		countryName: 'Bangladesh',
	},
	{
		id: 18,
		countryCode: 'BB',
		countryName: 'Barbados',
	},
	{
		id: 19,
		countryCode: 'BY',
		countryName: 'Belarus',
	},
	{
		id: 20,
		countryCode: 'BE',
		countryName: 'Belgium',
	},
	{
		id: 21,
		countryCode: 'BZ',
		countryName: 'Belize',
	},
	{
		id: 22,
		countryCode: 'BJ',
		countryName: 'Benin',
	},
	{
		id: 23,
		countryCode: 'BM',
		countryName: 'Bermuda',
	},
	{
		id: 24,
		countryCode: 'BT',
		countryName: 'Bhutan',
	},
	{
		id: 25,
		countryCode: 'BO',
		countryName: 'Bolivia',
	},
	{
		id: 220,
		countryCode: 'BQ',
		countryName: 'Bonaire, Sint Eustatius and Saba',
	},
	{
		id: 26,
		countryCode: 'BA',
		countryName: 'Bosnia-Herzegovina',
	},
	{
		id: 27,
		countryCode: 'BW',
		countryName: 'Botswana',
	},
	{
		id: 28,
		countryCode: 'BR',
		countryName: 'Brazil',
	},
	{
		id: 29,
		countryCode: 'VG',
		countryName: 'British Virgin Islands',
	},
	{
		id: 30,
		countryCode: 'BN',
		countryName: 'Brunei Darussalam',
	},
	{
		id: 31,
		countryCode: 'BG',
		countryName: 'Bulgaria',
	},
	{
		id: 32,
		countryCode: 'BF',
		countryName: 'Burkina Faso',
	},
	{
		id: 33,
		countryCode: 'MM',
		countryName: 'Burma (Myanmar)',
	},
	{
		id: 34,
		countryCode: 'BI',
		countryName: 'Burundi',
	},
	{
		id: 35,
		countryCode: 'KH',
		countryName: 'Cambodia',
	},
	{
		id: 36,
		countryCode: 'CM',
		countryName: 'Cameroon',
	},
	{
		id: 37,
		countryCode: 'CA',
		countryName: 'Canada',
	},
	{
		id: 38,
		countryCode: 'CV',
		countryName: 'Cape Verde',
	},
	{
		id: 39,
		countryCode: 'KY',
		countryName: 'Cayman Islands',
	},
	{
		id: 40,
		countryCode: 'CF',
		countryName: 'Central African Republic',
	},
	{
		id: 41,
		countryCode: 'TD',
		countryName: 'Chad',
	},
	{
		id: 42,
		countryCode: 'CL',
		countryName: 'Chile',
	},
	{
		id: 43,
		countryCode: 'CN',
		countryName: 'China',
	},
	{
		id: 44,
		countryCode: 'CO',
		countryName: 'Colombia',
	},
	{
		id: 45,
		countryCode: 'KM',
		countryName: 'Comoros',
	},
	{
		id: 48,
		countryCode: 'CR',
		countryName: 'Costa Rica',
	},
	{
		id: 49,
		countryCode: 'CI',
		countryName: "Cote d'Ivoire (Ivory Coast)",
	},
	{
		id: 50,
		countryCode: 'HR',
		countryName: 'Croatia',
	},
	{
		id: 51,
		countryCode: 'CU',
		countryName: 'Cuba',
	},
	{
		id: 221,
		countryCode: 'CW',
		countryName: 'Curacao',
	},
	{
		id: 52,
		countryCode: 'CY',
		countryName: 'Cyprus',
	},
	{
		id: 53,
		countryCode: 'CZ',
		countryName: 'Czech Republic',
	},
	{
		id: 105,
		countryCode: 'KP',
		countryName: "Democratic People's Republic of (North) Korea",
	},
	{
		id: 46,
		countryCode: 'CD',
		countryName: 'Democratic Republic Of The Congo',
	},
	{
		id: 54,
		countryCode: 'DK',
		countryName: 'Denmark',
	},
	{
		id: 55,
		countryCode: 'DJ',
		countryName: 'Djibouti',
	},
	{
		id: 56,
		countryCode: 'DM',
		countryName: 'Dominica',
	},
	{
		id: 57,
		countryCode: 'DO',
		countryName: 'Dominican Republic',
	},
	{
		id: 58,
		countryCode: 'EC',
		countryName: 'Ecuador',
	},
	{
		id: 59,
		countryCode: 'EG',
		countryName: 'Egypt',
	},
	{
		id: 60,
		countryCode: 'SV',
		countryName: 'El Salvador',
	},
	{
		id: 232,
		countryCode: 'GB',
		countryName: 'England (United Kingdom)',
	},
	{
		id: 61,
		countryCode: 'GQ',
		countryName: 'Equatorial Guinea',
	},
	{
		id: 62,
		countryCode: 'ER',
		countryName: 'Eritrea',
	},
	{
		id: 63,
		countryCode: 'EE',
		countryName: 'Estonia',
	},
	{
		id: 183,
		countryCode: 'SZ',
		countryName: 'Eswatini',
	},
	{
		id: 64,
		countryCode: 'ET',
		countryName: 'Ethiopia',
	},
	{
		id: 65,
		countryCode: 'FK',
		countryName: 'Falkland Islands',
	},
	{
		id: 66,
		countryCode: 'FO',
		countryName: 'Faroe Islands',
	},
	{
		id: 67,
		countryCode: 'FJ',
		countryName: 'Fiji',
	},
	{
		id: 68,
		countryCode: 'FI',
		countryName: 'Finland',
	},
	{
		id: 69,
		countryCode: 'FR',
		countryName: 'France',
	},
	{
		id: 70,
		countryCode: 'GF',
		countryName: 'French Guiana',
	},
	{
		id: 71,
		countryCode: 'PF',
		countryName: 'French Polynesia',
	},
	{
		id: 72,
		countryCode: 'GA',
		countryName: 'Gabon',
	},
	{
		id: 73,
		countryCode: 'GM',
		countryName: 'Gambia',
	},
	{
		id: 75,
		countryCode: 'DE',
		countryName: 'Germany',
	},
	{
		id: 76,
		countryCode: 'GH',
		countryName: 'Ghana',
	},
	{
		id: 77,
		countryCode: 'GI',
		countryName: 'Gibraltar',
	},
	{
		id: 79,
		countryCode: 'GR',
		countryName: 'Greece',
	},
	{
		id: 80,
		countryCode: 'GL',
		countryName: 'Greenland',
	},
	{
		id: 81,
		countryCode: 'GD',
		countryName: 'Grenada',
	},
	{
		id: 82,
		countryCode: 'GP',
		countryName: 'Guadeloupe',
	},
	{
		id: 223,
		countryCode: 'GU',
		countryName: 'Guam',
	},
	{
		id: 83,
		countryCode: 'GT',
		countryName: 'Guatemala',
	},
	{
		id: 84,
		countryCode: 'GN',
		countryName: 'Guinea',
	},
	{
		id: 85,
		countryCode: 'GW',
		countryName: 'Guinea-Bissau',
	},
	{
		id: 86,
		countryCode: 'GY',
		countryName: 'Guyana',
	},
	{
		id: 87,
		countryCode: 'HT',
		countryName: 'Haiti',
	},
	{
		id: 88,
		countryCode: 'HN',
		countryName: 'Honduras',
	},
	{
		id: 89,
		countryCode: 'HK',
		countryName: 'Hong Kong',
	},
	{
		id: 90,
		countryCode: 'HU',
		countryName: 'Hungary',
	},
	{
		id: 91,
		countryCode: 'IS',
		countryName: 'Iceland',
	},
	{
		id: 92,
		countryCode: 'IN',
		countryName: 'India',
	},
	{
		id: 93,
		countryCode: 'ID',
		countryName: 'Indonesia',
	},
	{
		id: 94,
		countryCode: 'IR',
		countryName: 'Iran',
	},
	{
		id: 95,
		countryCode: 'IQ',
		countryName: 'Iraq',
	},
	{
		id: 96,
		countryCode: 'IE',
		countryName: 'Ireland',
	},
	{
		id: 97,
		countryCode: 'IL',
		countryName: 'Israel',
	},
	{
		id: 98,
		countryCode: 'IT',
		countryName: 'Italy',
	},
	{
		id: 99,
		countryCode: 'JM',
		countryName: 'Jamaica',
	},
	{
		id: 100,
		countryCode: 'JP',
		countryName: 'Japan',
	},
	{
		id: 101,
		countryCode: 'JO',
		countryName: 'Jordan',
	},
	{
		id: 102,
		countryCode: 'KZ',
		countryName: 'Kazakhstan',
	},
	{
		id: 103,
		countryCode: 'KE',
		countryName: 'Kenya',
	},
	{
		id: 104,
		countryCode: 'KI',
		countryName: 'Kiribati',
	},
	{
		id: 230,
		countryCode: 'XZ',
		countryName: 'Kosovo',
	},
	{
		id: 107,
		countryCode: 'KW',
		countryName: 'Kuwait',
	},
	{
		id: 108,
		countryCode: 'KG',
		countryName: 'Kyrgyzstan',
	},
	{
		id: 109,
		countryCode: 'LA',
		countryName: 'Laos',
	},
	{
		id: 110,
		countryCode: 'LV',
		countryName: 'Latvia',
	},
	{
		id: 111,
		countryCode: 'LB',
		countryName: 'Lebanon',
	},
	{
		id: 112,
		countryCode: 'LS',
		countryName: 'Lesotho',
	},
	{
		id: 113,
		countryCode: 'LR',
		countryName: 'Liberia',
	},
	{
		id: 114,
		countryCode: 'LY',
		countryName: 'Libya',
	},
	{
		id: 115,
		countryCode: 'LI',
		countryName: 'Liechtenstein',
	},
	{
		id: 116,
		countryCode: 'LT',
		countryName: 'Lithuania',
	},
	{
		id: 117,
		countryCode: 'LU',
		countryName: 'Luxembourg',
	},
	{
		id: 118,
		countryCode: 'MO',
		countryName: 'Macao',
	},
	{
		id: 120,
		countryCode: 'MG',
		countryName: 'Madagascar',
	},
	{
		id: 121,
		countryCode: 'MW',
		countryName: 'Malawi',
	},
	{
		id: 122,
		countryCode: 'MY',
		countryName: 'Malaysia',
	},
	{
		id: 123,
		countryCode: 'MV',
		countryName: 'Maldives',
	},
	{
		id: 124,
		countryCode: 'ML',
		countryName: 'Mali',
	},
	{
		id: 125,
		countryCode: 'MT',
		countryName: 'Malta',
	},
	{
		id: 215,
		countryCode: 'MH',
		countryName: 'Marshall Islands',
	},
	{
		id: 126,
		countryCode: 'MQ',
		countryName: 'Martinique',
	},
	{
		id: 127,
		countryCode: 'MR',
		countryName: 'Mauritania',
	},
	{
		id: 128,
		countryCode: 'MU',
		countryName: 'Mauritius',
	},
	{
		id: 129,
		countryCode: 'MX',
		countryName: 'Mexico',
	},
	{
		id: 216,
		countryCode: 'FM',
		countryName: 'Micronesia',
	},
	{
		id: 130,
		countryCode: 'MD',
		countryName: 'Moldova',
	},
	{
		id: 131,
		countryCode: 'MN',
		countryName: 'Mongolia',
	},
	{
		id: 132,
		countryCode: 'MS',
		countryName: 'Montserrat',
	},
	{
		id: 133,
		countryCode: 'MA',
		countryName: 'Morocco',
	},
	{
		id: 134,
		countryCode: 'MZ',
		countryName: 'Mozambique',
	},
	{
		id: 135,
		countryCode: 'NA',
		countryName: 'Namibia',
	},
	{
		id: 136,
		countryCode: 'NR',
		countryName: 'Nauru',
	},
	{
		id: 137,
		countryCode: 'NP',
		countryName: 'Nepal',
	},
	{
		id: 138,
		countryCode: 'NL',
		countryName: 'Netherlands',
	},
	{
		id: 140,
		countryCode: 'NC',
		countryName: 'New Caledonia',
	},
	{
		id: 141,
		countryCode: 'NZ',
		countryName: 'New Zealand',
	},
	{
		id: 142,
		countryCode: 'NI',
		countryName: 'Nicaragua',
	},
	{
		id: 143,
		countryCode: 'NE',
		countryName: 'Niger',
	},
	{
		id: 144,
		countryCode: 'NG',
		countryName: 'Nigeria',
	},
	{
		id: 235,
		countryCode: 'GB',
		countryName: 'Northern Ireland (United Kingdom)',
	},
	{
		id: 224,
		countryCode: 'MP',
		countryName: 'Northern Mariana Islands',
	},
	{
		id: 145,
		countryCode: 'NO',
		countryName: 'Norway',
	},
	{
		id: 146,
		countryCode: 'OM',
		countryName: 'Oman',
	},
	{
		id: 147,
		countryCode: 'PK',
		countryName: 'Pakistan',
	},
	{
		id: 225,
		countryCode: 'PW',
		countryName: 'Palau',
	},
	{
		id: 148,
		countryCode: 'PA',
		countryName: 'Panama',
	},
	{
		id: 149,
		countryCode: 'PG',
		countryName: 'Papua New Guinea',
	},
	{
		id: 150,
		countryCode: 'PY',
		countryName: 'Paraguay',
	},
	{
		id: 151,
		countryCode: 'PE',
		countryName: 'Peru',
	},
	{
		id: 152,
		countryCode: 'PH',
		countryName: 'Philippines',
	},
	{
		id: 153,
		countryCode: 'PN',
		countryName: 'Pitcairn Island',
	},
	{
		id: 154,
		countryCode: 'PL',
		countryName: 'Poland',
	},
	{
		id: 155,
		countryCode: 'PT',
		countryName: 'Portugal',
	},
	{
		id: 226,
		countryCode: 'PR',
		countryName: 'Puerto Rico',
	},
	{
		id: 156,
		countryCode: 'QA',
		countryName: 'Qatar',
	},
	{
		id: 106,
		countryCode: 'KR',
		countryName: 'Republic of (South) Korea',
	},
	{
		id: 74,
		countryCode: 'GE',
		countryName: 'Republic Of Georgia',
	},
	{
		id: 119,
		countryCode: 'MK',
		countryName: 'Republic of North Macedonia',
	},
	{
		id: 218,
		countryCode: 'ME',
		countryName: 'Republic of Montenegro',
	},
	{
		id: 217,
		countryCode: 'RS',
		countryName: 'Republic of Serbia',
	},
	{
		id: 236,
		countryCode: 'SS',
		countryName: 'Republic of South Sudan',
	},
	{
		id: 47,
		countryCode: 'CG',
		countryName: 'Republic Of The Congo',
	},
	{
		id: 157,
		countryCode: 'RE',
		countryName: 'Reunion',
	},
	{
		id: 158,
		countryCode: 'RO',
		countryName: 'Romania',
	},
	{
		id: 159,
		countryCode: 'RU',
		countryName: 'Russia',
	},
	{
		id: 160,
		countryCode: 'RW',
		countryName: 'Rwanda',
	},
	{
		id: 162,
		countryCode: 'SH',
		countryName: 'Saint Helena',
	},
	{
		id: 163,
		countryCode: 'LC',
		countryName: 'Saint Lucia',
	},
	{
		id: 164,
		countryCode: 'PM',
		countryName: 'Saint Pierre & Miquelon',
	},
	{
		id: 165,
		countryCode: 'VC',
		countryName: 'Saint Vincent & Grenadines',
	},
	{
		id: 166,
		countryCode: 'SM',
		countryName: 'San Marino',
	},
	{
		id: 167,
		countryCode: 'ST',
		countryName: 'Sao Tome & Principe',
	},
	{
		id: 168,
		countryCode: 'SA',
		countryName: 'Saudi Arabia',
	},
	{
		id: 233,
		countryCode: 'GB',
		countryName: 'Scotland (United Kingdom)',
	},
	{
		id: 169,
		countryCode: 'SN',
		countryName: 'Senegal',
	},
	{
		id: 171,
		countryCode: 'SC',
		countryName: 'Seychelles',
	},
	{
		id: 172,
		countryCode: 'SL',
		countryName: 'Sierra Leone',
	},
	{
		id: 173,
		countryCode: 'SG',
		countryName: 'Singapore',
	},
	{
		id: 228,
		countryCode: 'SX',
		countryName: 'Sint Maarten',
	},
	{
		id: 174,
		countryCode: 'SK',
		countryName: 'Slovak Republic (Slovakia)',
	},
	{
		id: 175,
		countryCode: 'SI',
		countryName: 'Slovenia',
	},
	{
		id: 176,
		countryCode: 'SB',
		countryName: 'Solomon Islands',
	},
	{
		id: 177,
		countryCode: 'SO',
		countryName: 'Somalia',
	},
	{
		id: 178,
		countryCode: 'ZA',
		countryName: 'South Africa',
	},
	{
		id: 179,
		countryCode: 'ES',
		countryName: 'Spain',
	},
	{
		id: 180,
		countryCode: 'LK',
		countryName: 'Sri Lanka',
	},
	{
		id: 161,
		countryCode: 'KN',
		countryName: 'St. Christopher (St. Kitts) & Nevis',
	},
	{
		id: 181,
		countryCode: 'SD',
		countryName: 'Sudan',
	},
	{
		id: 182,
		countryCode: 'SR',
		countryName: 'Suriname',
	},
	{
		id: 184,
		countryCode: 'SE',
		countryName: 'Sweden',
	},
	{
		id: 185,
		countryCode: 'CH',
		countryName: 'Switzerland',
	},
	{
		id: 186,
		countryCode: 'SY',
		countryName: 'Syria',
	},
	{
		id: 187,
		countryCode: 'TW',
		countryName: 'Taiwan',
	},
	{
		id: 188,
		countryCode: 'TJ',
		countryName: 'Tajikistan',
	},
	{
		id: 189,
		countryCode: 'TZ',
		countryName: 'Tanzania',
	},
	{
		id: 190,
		countryCode: 'TH',
		countryName: 'Thailand',
	},
	{
		id: 219,
		countryCode: 'CN',
		countryName: 'Tibet (China)',
	},
	{
		id: 229,
		countryCode: 'TL',
		countryName: 'Timor Leste',
	},
	{
		id: 191,
		countryCode: 'TG',
		countryName: 'Togo',
	},
	{
		id: 192,
		countryCode: 'TO',
		countryName: 'Tonga',
	},
	{
		id: 193,
		countryCode: 'TT',
		countryName: 'Trinidad & Tobago',
	},
	{
		id: 194,
		countryCode: 'SH',
		countryName: 'Tristan da Cunha',
	},
	{
		id: 195,
		countryCode: 'TN',
		countryName: 'Tunisia',
	},
	{
		id: 196,
		countryCode: 'TR',
		countryName: 'Turkiye (Turkey)',
	},
	{
		id: 197,
		countryCode: 'TM',
		countryName: 'Turkmenistan',
	},
	{
		id: 198,
		countryCode: 'TC',
		countryName: 'Turks & Caicos Islands',
	},
	{
		id: 199,
		countryCode: 'TV',
		countryName: 'Tuvalu',
	},
	{
		id: 200,
		countryCode: 'UG',
		countryName: 'Uganda',
	},
	{
		id: 201,
		countryCode: 'UA',
		countryName: 'Ukraine',
	},
	{
		id: 202,
		countryCode: 'AE',
		countryName: 'United Arab Emirates',
	},
	{
		id: 231,
		countryCode: 'GB',
		countryName: 'United Kingdom',
	},
	{
		id: 204,
		countryCode: 'UY',
		countryName: 'Uruguay',
	},
	{
		id: 205,
		countryCode: 'UZ',
		countryName: 'Uzbekistan',
	},
	{
		id: 206,
		countryCode: 'VU',
		countryName: 'Vanuatu',
	},
	{
		id: 207,
		countryCode: 'VA',
		countryName: 'Vatican City',
	},
	{
		id: 208,
		countryCode: 'VE',
		countryName: 'Venezuela',
	},
	{
		id: 209,
		countryCode: 'VN',
		countryName: 'Vietnam',
	},
	{
		id: 227,
		countryCode: 'VI',
		countryName: 'Virgin Islands',
	},
	{
		id: 234,
		countryCode: 'GB',
		countryName: 'Wales (United Kingdom)',
	},
	{
		id: 210,
		countryCode: 'WF',
		countryName: 'Wallis & Futuna',
	},
	{
		id: 211,
		countryCode: 'WS',
		countryName: 'Western Samoa',
	},
	{
		id: 212,
		countryCode: 'YE',
		countryName: 'Yemen',
	},
	{
		id: 213,
		countryCode: 'ZM',
		countryName: 'Zambia',
	},
	{
		id: 214,
		countryCode: 'ZW',
		countryName: 'Zimbabwe',
	},
]);
